import { render, staticRenderFns } from "./BaseIconButtonEdit.vue?vue&type=template&id=1921a1a0&scoped=true&"
import script from "./BaseIconButtonEdit.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921a1a0",
  null
  
)

export default component.exports